import { Box, Dialog, DialogContent, Divider, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CustomTextField from '../../../../../common/components/customized/customtextfield/CustomTextField';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useFieldArray, useForm } from 'react-hook-form';
import CustomButton from '../../../../../common/components/buttons/CustomButton';
import CustomSelect from '../../../../../common/components/customized/customselect/CustomSelect';
import CustomDateTimeCalendar from '../../../../../common/components/customized/customdatetimecalendar/CustomDateTimeCalendar';
import { useAppDispatch, useAppSelector } from '../../../../../app/redux/hooks';
import CustomIconButton from '../../../../../common/components/buttons/CustomIconButton';
import GoogleSearchBox from '../../../../../common/components/maps/googlesearchbox/GoogleSearchBox';
import {
  map,
  updateCenter,
  updateZoom
} from '../../../../../common/redux/reducer/commonSlices/mapSlice';
import GoogleMarkers from '../../../../../common/components/maps/googlemarkers/GoogleMarkers';
import './AddLoads.scss';
import dayjs from 'dayjs';
import { AddCircleOutline } from '@mui/icons-material';
import CustomMultiSelect from '../../../../../common/components/customized/custommultiselect/CustomMultiSelect';
import {
  addLoads,
  updateLoads
} from '../../../redux/reducer/truckManagementSlices/loadsSlice';
import { Icon } from '@iconify/react';
import GoogleMap from '../../../../../common/components/maps/googlemap/GoogleMap';
import { convertToEpoch, findAddress } from '../../../../../utils/commonFunctions';
import AddIcon from '@mui/icons-material/Add';
import data from '@iconify-icons/mdi/minus';

const loadSchema: any = yup.object().shape({
  truckLoad: yup
    .string()
    .required('Truck Load is required')
    .min(1, 'Truck Load is required'),
  loadType: yup
    .string()
    .required('Load Type is required')
    .min(1, 'Load Type is required'),
  weightUnit: yup
    .string()
    .trim()
    .typeError('Select the  Unladen Weight')
    .required('Unladen Weight is required'),
  dimensionUnit: yup
    .string()
    .trim()
    .typeError('Select the  Dimension Unit')
    .required('Dimension Unit is required'),
  weight: yup
    .number()
    .required('Enter the Weight')
    .min(2, 'Enter a valid Weight')
    .typeError('Enter valid Weight'),
  length: yup.number().when('loadType', {
    is: 'Tanker',
    then: () => yup.number().notRequired(),
    otherwise: () =>
      yup
        .number()
        .required('Enter the Length')
        .min(2, 'Enter a valid Length')
        .typeError('Enter valid Length')
  }),

  width: yup.number().when('loadType', {
    is: (val: any) => {
      return val === 'Tanker';
    },
    then: () => yup.number().notRequired(),
    otherwise: () =>
      yup
        .number()
        .required('Enter the Width')
        .min(2, 'Enter a valid Width')
        .typeError('Enter valid Width')
  }),
  height: yup.number().when('loadType', {
    is: 'Tanker',
    then: () => yup.number().notRequired(),
    otherwise: () =>
      yup
        .number()
        .required('Enter the Height')
        .min(2, 'Enter a valid Height')
        .typeError('Enter valid length')
  }),

  customer: yup.string().required('Select the Customer'),
  customeraddress: yup.object().shape({
    customerLocation: yup.string().required('Enter address location'),
    customerLat: yup.number().required('Enter address location'),
    customerLng: yup.number().required('Enter address location')
  }),
  loadcost: yup
    .number()
    .required('Enter the Load Cost')
    .typeError('Enter valid Load Cost'),
  freight: yup.array().when('loadType', {
    is: (value: any) => value === 'General Cargo' || value === undefined,
    then: () =>
      yup
        .array()
        .of(
          yup.object().shape({
            id: yup.string().required(),
            label: yup.string().required()
          })
        )
        .required('freight is required')
        .min(1, 'Freight is required'),
    otherwise: () =>
      yup
        .array()
        .of(
          yup.object().shape({
            id: yup.string().required(),
            label: yup.string().required('Label is required')
          })
        )
        .notRequired()
  }),
  description: yup.string().trim().notRequired(),
  loads: yup.array().of(
    yup.object().shape({
      shipper: yup.string().required('Select the Shipper'),
      consignee: yup.string().required('Select the Consignee'),
      pickupDate: yup
        .date()
        .required('Pickup Date is required')
        .typeError('Pickup Date is invalid'),
      deliveryDate: yup
        .date()
        .required('Delivery Date is required')
        .typeError('Delivery Date is invalid')
        .test(
          'deliveryDate',
          'Delivery date should be greater than pickup date',
          function (value, context) {
            const { pickupDate } = context.parent;
            const date = new Date(pickupDate);
            date.setMinutes(date.getMinutes() + 30);
            if (!date || !value) {
              return true || null;
            }
            return value > date;
          }
        ),

      pickupLocation: yup.object().shape({
        source: yup.string().required('Enter pickup location'),
        startLat: yup.number().required('Enter pickup location'),
        startLng: yup.number().required('Enter pickup location')
      }),
      deliveryLocation: yup.object().shape({
        destination: yup.string().required('Enter delivery location'),
        endLat: yup.number().required('Enter delivery location'),
        endLng: yup.number().required('Enter delivery location')
      }),
      PickupInstruction: yup.string().trim().notRequired(),
      DeliveryInstruction: yup.string().trim().notRequired()
    })
  )
});

const loadSchema2: any = yup.object().shape({
  address: yup.object().shape({
    addressLocation: yup.string().required('Enter address location'),
    addressLat: yup.number().required('Enter address location'),
    addressLng: yup.number().required('Enter address location')
  })
});

interface Addload {
  open: boolean;
  setOpen: any;
  roleType: string;
  filteredRow: any;
  setFilteredRow: any;
  stackeholdernames: any;
  isLoading?: any;
  setPageNo?: any;
  setPageSize?: any;
  setTablePayload?: any;
}

interface TextField {
  id: string;
  label: string;
  field: any;
  placeholder: string;
  inputProps: {
    maxLength?: number;
    style?: React.CSSProperties;
  };
  options?: { id: string; label: string }[] | any;
  value?: string;
  function?: any;
}

const AddLoad = ({
  open,
  setOpen,
  roleType,
  filteredRow,
  stackeholdernames,
  setFilteredRow,
  setPageNo,
  setPageSize,
  setTablePayload
}: Addload) => {
  const [address, setAddress] = useState<any>(null);
  const [pickupDate, setPickupDate] = useState<any>({});
  const [multipleMarkers, setMultipleMarkers] = useState<any>([]);
  const [deliveryDate, setDeliveryDate] = useState({});
  const [loadMarker, setLoadMarker] = useState<any>([]);
  const [pickupLocation, setPickupLocation] = useState<any>([]);
  const [deliveryLocation, setDeliveryLocation] = useState<any>([]);
  const [customerAddress, setCustomerAddress] = useState<any>(null);
  const [disabled, setDisabled] = useState<any>(false);
  const [getStartDate, setGetStartDate] = useState<Date | null>(null);
  const [optional, setOptional] = useState<any>();
  const [view, setView] = useState(true);
  const [index, setIndex] = useState<any>();
  const [name, setName] = useState<any>();
  const [fromDate, setFromDate] = useState<any>();
  const [loadData, setLoadData] = useState<any>([
    {
      shipper: '',
      consignee: '',
      pickupDate: null,
      deliveryDate: null,
      pickupLocation: {},
      deliveryLocation: {},
      PickupInstruction: '',
      DeliveryInstruction: ''
    }
  ]);

  const { isLoading: addLoading } = useAppSelector(state => state?.loadsAll);
  const { isLoading: updateLoading } = useAppSelector(state => state?.updateLoads);
  const { activeList } = useAppSelector(state => state.activeNames);
  const { freightList } = useAppSelector(state => state.freightactive);
  const dispatch = useAppDispatch();

  const {
    control,
    handleSubmit,
    setValue,
    reset,
    getValues,
    clearErrors,
    formState: { errors }
  } = useForm<any>({
    resolver: yupResolver(loadSchema),
    defaultValues: {
      truckLoad: '',
      weight: null,
      customer: '',
      loadcost: null,
      freight: [],
      loads: loadData
    }
  });

  const {
    setValue: setMapValue,
    clearErrors: clearMapErrors,
    control: mapControl,
    handleSubmit: handleSubmit2
  } = useForm({
    resolver: yupResolver(loadSchema2)
  });

  const { fields, append, remove, update } = useFieldArray({
    control,
    name: 'loads'
  });

  const ConsigneeList =
    activeList?.Consignee?.length > 0
      ? activeList?.Consignee?.map((value: any, index: number) => ({
          id: value,
          label: value
        }))
      : [];

  const CustomerList =
    activeList?.Customer?.length > 0
      ? activeList?.Customer?.map((value: any, index: number) => ({
          id: value,
          label: value
        }))
      : [];

  const ShipperList =
    activeList?.Shipper?.length > 0
      ? activeList?.Shipper?.map((value: any, index: number) => ({
          id: value,
          label: value
        }))
      : [];

  const freightName =
    freightList?.length > 0
      ? freightList?.map((value: any, index: number) => ({
          id: value,
          label: value
        }))
      : [];

  const loadItems = [
    { id: 'General Cargo', label: 'General Cargo' },
    { id: 'Refrigerator', label: 'Refrigerator' },
    { id: 'Tanker', label: 'Tanker' }
  ];

  const dimensionFields: TextField[] = [
    {
      id: '7',
      label: 'Dimension Unit',
      field: 'dimensionUnit',
      placeholder: 'Dimension Unit',
      inputProps: { maxLength: 10 },
      options: [
        {
          id: 'm',
          label: 'm'
        },
        {
          id: 'ft',
          label: 'ft'
        }
      ]
    },
    {
      id: '8',
      label: 'Length',
      field: 'length',
      placeholder: 'Length',
      inputProps: { maxLength: 10 }
    },
    {
      id: '9',
      label: 'Width',
      field: 'width',
      placeholder: 'Width',
      inputProps: { maxLength: 5 }
    },
    {
      id: '10',
      label: 'Height',
      field: 'height',
      placeholder: 'Height',
      inputProps: { maxLength: 16 }
    },
    {
      id: '11',
      label: 'Weight Unit',
      field: 'weightUnit',
      placeholder: 'Weight Unit',
      inputProps: { maxLength: 16 },
      options: [
        {
          id: 'kg',
          label: 'kg'
        },
        {
          id: 'ton',
          label: 'ton'
        },
        {
          id: 'pounds',
          label: 'pounds'
        }
      ]
    },
    {
      id: '12',
      label: 'Weight',
      field: 'weight',
      placeholder: 'Weight',
      inputProps: { maxLength: 10 }
    },
    {
      id: '12',
      label: 'Total Cost',
      field: 'loadcost',
      placeholder: 'Total Cost',
      inputProps: { maxLength: 10 }
    }
  ];

  const truckLoadList = [
    { id: 'FTL', label: 'FTL' },
    { id: 'LTL', label: 'LTL' }
  ];

  const options = [
    {
      label: 'Add Customer',
      value: 'Customer',
      icon: <AddIcon fontSize='small' sx={{ color: '#3239EA' }} />
    },
    {
      label: 'Add Shipper',
      value: 'Shipper',
      icon: <AddIcon fontSize='small' sx={{ color: '#3239EA' }} />
    },
    {
      label: 'Add Consignee',
      value: 'Consignee',
      icon: <AddIcon fontSize='small' sx={{ color: '#3239EA' }} />
    }
  ];

  const handleFields = () => {
    const newValues = {
      shipper: '',
      consignee: '',
      pickupDate: null,
      deliveryDate: null,
      pickupLocation: {},
      deliveryLocation: {}
    };
    setLoadData((prev: any) => [...prev, newValues]);
    append(newValues);
  };

  const mapSubmit = (data: any) => {
    if (name === 'pickupLocation') {
      setValue(`loads.${index}.${name}`, {
        source: data?.address?.addressLocation,
        startLat: data?.address?.addressLat,
        startLng: data?.address?.addressLng
      });
      setPickupLocation((prev: any) => {
        let updatedLocation = [...prev];
        let pickupAddress = {
          formatted_address: address?.formatted_address,
          lat: address?.geometry?.location?.lat(),
          lng: address?.geometry?.location?.lng()
        };
        updatedLocation[index] = pickupAddress;
        return updatedLocation;
      });
      clearErrors(`loads.${index}.${name}`);
    } else if (name === 'deliveryLocation') {
      setValue(`loads.${index}.${name}`, {
        destination: data?.address?.addressLocation,
        endLat: data?.address?.addressLat,
        endLng: data?.address?.addressLng
      });
      setDeliveryLocation((prev: any) => {
        let updatedLocation = [...prev];
        let deliveryAddress = {
          formatted_address: address?.formatted_address,
          lat: address?.geometry?.location?.lat(),
          lng: address?.geometry?.location?.lng()
        };
        updatedLocation[index] = deliveryAddress;
        return updatedLocation;
      });
      clearErrors(`loads.${index}.${name}`);
    } else {
      setCustomerAddress({
        formatted_address: data?.address?.addressLocation,
        lat: data?.address?.addressLat,
        lng: data?.address?.addressLng
      });
      setValue('customeraddress', {
        customerLocation: data?.address?.addressLocation,
        customerLat: data?.address?.addressLat,
        customerLng: data?.address?.addressLng
      });
      clearErrors('customeraddress');
    }
    setMapValue('address', {});
    setAddress(null);
    dispatch(map([]));
    setView(true);
  };

  const onSubmit = async (data: any) => {
    const freightList = data?.freight?.map((item: any) => {
      return item?.id;
    });
    if (filteredRow !== null) {
      let updatePayload: any = {
        loadType: data.loadType,
        truckLoadType: data.truckLoad,
        isSameAddress: 0,
        weightUnit: data.weightUnit,
        weight: data.weight,
        length: data.length,
        width: data.width,
        height: data.height,
        totalCost: data.loadcost,
        description: data.description,
        customerId: data.customer,
        freightNumbers: freightList,
        dimensionalUnit: data.dimensionUnit,
        customerAddress: data?.customeraddress?.customerLocation,
        customerLatitude: data?.customeraddress?.customerLat,
        customerLongitude: data?.customeraddress?.customerLng,
        stakeholderPairModels: data.loads.map((load: any) => ({
          shipperId: load.shipper,
          consigneeId: load.consignee,
          pickUpDate: convertToEpoch(load.pickupDate),
          deliveryDate: convertToEpoch(load.deliveryDate),
          pickUpAddress: load.pickupLocation.source,
          deliveryAddress: load.deliveryLocation.destination,
          pickUpLatitude: load?.pickupLocation?.startLat,
          pickUpLongitude: load?.pickupLocation?.startLng,
          deliveryLatitude: load.deliveryLocation.endLat,
          deliveryLongitude: load.deliveryLocation.endLng,
          pickupInstructions: load.PickupInstruction,
          deliveryInstructions: load.DeliveryInstruction,
          isPickupAddressSame: 0,
          isDeliveryAddressSame: 0
        }))
      };
      let payload: { updatePayload: any; id: any } = {
        updatePayload: updatePayload,
        id: filteredRow.id
      };
      const action1 = await dispatch(updateLoads(payload));
      if (action1.type === updateLoads.fulfilled.type) {
        setOpen(false);
        setTablePayload({
          pageNo: 1,
          pageSize: 5,
          sortColumnName: null,
          sortBy: null,
          searchInput: null,
          searchColumnName: null
        });
        setPageNo(1);
        setPageSize(5);
      }
    } else {
      const action2 = await dispatch(
        addLoads({
          loadType: data.loadType,
          truckLoadType: data.truckLoad,
          isSameAddress: 0,
          weightUnit: data.weightUnit,
          weight: data.weight,
          length: data.length,
          width: data.width,
          height: data.height,
          totalCost: data.loadcost,
          description: data.description,
          customerId: data.customer,
          freightNumbers: freightList,
          dimensionalUnit: data.dimensionUnit,
          customerAddress: data?.customeraddress?.customerLocation,
          customerLatitude: data?.customeraddress?.customerLat,
          customerLongitude: data?.customeraddress?.customerLng,
          stakeholderPairModels: data.loads.map((load: any) => ({
            shipperId: load.shipper,
            consigneeId: load.consignee,
            pickUpDate: convertToEpoch(load.pickupDate),
            deliveryDate: convertToEpoch(load.deliveryDate),
            pickUpAddress: load.pickupLocation.source,
            deliveryAddress: load.deliveryLocation.destination,
            pickUpLatitude: load?.pickupLocation?.startLat,
            pickUpLongitude: load?.pickupLocation?.startLng,
            deliveryLatitude: load.deliveryLocation.endLat,
            deliveryLongitude: load.deliveryLocation.endLng,
            pickupInstructions: load.PickupInstruction,
            deliveryInstructions: load.DeliveryInstruction,
            isPickupAddressSame: 0,
            isDeliveryAddressSame: 0
          }))
        })
      );
      if (action2.type === addLoads.fulfilled.type) {
        setOpen(false);
        setTablePayload({
          pageNo: 1,
          pageSize: 5,
          sortColumnName: null,
          sortBy: null,
          searchInput: null,
          searchColumnName: null
        });
        setPageNo(1);
        setPageSize(5);
      }
    }
  };

  const handleClose = () => {
    reset();
    setFilteredRow(null);
    setOpen(false);
  };

  const handleFromDate = (index: number, date: any) => {
    const fromDate = date?.$d;
    setGetStartDate(fromDate);
    setValue(`loads.${index}.pickupDate`, fromDate);
    setPickupDate((prev: any) => ({ ...prev, [index]: fromDate }));
    clearErrors(`loads.${index}.pickupDate`);
  };

  const handleToDate = (index: number, date: any) => {
    const toDate = date?.$d;
    setValue(`loads.${index}.deliveryDate`, toDate);
    setDeliveryDate(prev => ({ ...prev, [index]: toDate }));
    clearErrors(`loads.${index}.deliveryDate`);
  };

  const handleCustomer = (address: any) => {
    if (address) {
      setCustomerAddress(address);
      setValue('customeraddress', {
        customerLocation: address?.formatted_address,
        customerLat: address?.geometry?.location?.lat(),
        customerLng: address?.geometry?.location?.lng()
      });
    }
  };

  const handlePickupLocationChange = (index: number, location: any) => {
    if (location?.formatted_address) {
      setPickupLocation((prev: any) => {
        let pickupAddress = {
          address: location?.formatted_address,
          lat: location?.geometry.location.lat(),
          lng: location?.geometry.location.lng()
        };
        const updatedLocations = [...prev];
        updatedLocations[index] = pickupAddress;
        return updatedLocations;
      });

      setValue(`loads.${index}.pickupLocation`, {
        source: location?.formatted_address,
        startLat: location?.geometry.location.lat(),
        startLng: location?.geometry.location.lng()
      });
    } else {
      setValue(`loads.${index}.pickupLocation`, {});
      setPickupLocation((prev: any) => {
        let pickupAddress = {
          address: '',
          lat: null,
          lng: null
        };
        const updatedLocations = [...prev];
        updatedLocations[index] = pickupAddress;
        return updatedLocations;
      });
    }
  };

  const handleDeliveryLocationChange = (index: number, location: any) => {
    if (location?.formatted_address) {
      let deliveryAddress = {
        address: location?.formatted_address,
        lat: location?.geometry.location.lat(),
        lng: location?.geometry.location.lng()
      };
      setDeliveryLocation((prev: any) => {
        const updatedLocations = [...prev];
        updatedLocations[index] = deliveryAddress;
        return updatedLocations;
      });
      setValue(`loads.${index}.deliveryLocation`, {
        destination: location?.formatted_address,
        endLat: location?.geometry.location.lat(),
        endLng: location?.geometry.location.lng()
      });
    } else {
      setValue(`loads.${index}.deliveryLocation`, {});
      setDeliveryLocation((prev: any) => {
        let pickupAddress = {
          address: '',
          lat: null,
          lng: null
        };
        const updatedLocations = [...prev];
        updatedLocations[index] = pickupAddress;
        return updatedLocations;
      });
    }
  };

  const searchAddressDialog = (index: any, name: string) => {
    setIndex(index);
    setName(name);
    setView(false);
  };

  const handleMapClick = async (e: any) => {
    const lat = e?.latLng?.lat();
    const lng = e?.latLng?.lng();
    dispatch(map([{ id: 1, lat, lng, name: 'location' }]));
    dispatch(updateCenter([{ id: 1, lat, lng, name: 'location' }]));
    dispatch(updateZoom([{ id: 1, lat, lng, name: 'location' }]));
    const fAdd = await findAddress(lat, lng);
    setAddress({
      formatted_address: fAdd,
      lat: lat,
      lng: lng
    });
    setMapValue('address', {
      addressLocation: fAdd,
      addressLat: lat,
      addressLng: lng
    });
    clearMapErrors('address');
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    yup.object().shape({
      destination: yup.string().required('Enter delivery location'),
      endLat: yup.number().required('Enter delivery location'),
      endLng: yup.number().required('Enter delivery location')
    });
    clearMapErrors('address');
  }, [address]);

  useEffect(() => {
    if (filteredRow) {
      const freightList = filteredRow?.freightNumbers?.map(
        (item: any, index: number) => ({
          id: item,
          label: item
        })
      );
      setValue('load', filteredRow?.loadName);
      setValue('loadType', filteredRow?.loadType);
      setValue('truckLoad', filteredRow?.truckLoadType);
      setValue('weight', filteredRow?.weight);
      setValue('description', filteredRow?.description);
      setValue('length', filteredRow?.length);
      setValue('width', filteredRow?.width);
      setValue('height', filteredRow?.height);
      setValue('customer', filteredRow?.customerId);
      setValue('loadcost', filteredRow?.totalCost);
      setValue('weightUnit', filteredRow?.weightUnit);
      setValue('dimensionUnit', filteredRow?.dimensionUnit);
      setValue('freight', freightList);

      setValue('customeraddress', {
        customerLocation: filteredRow?.customerAddress,
        customerLat: filteredRow?.customerLatitude,
        customerLng: filteredRow?.customerLongitude
      });
      setCustomerAddress({
        formatted_address: filteredRow?.customerAddress,
        lat: filteredRow?.customerLatitude,
        lng: filteredRow?.customerLongitude
      });
      filteredRow?.stakeholderPairModels?.map((field: any, index: number) => {
        setValue(`loads.${index}.shipper`, field?.shipperId);
        setValue(`loads.${index}.consignee`, field?.consigneeId);
        setValue(`loads.${index}.pickupDate`, dayjs(field?.pickUpDate * 1000));
        setValue(`loads.${index}.deliveryDate`, dayjs(field?.deliveryDate * 1000));
        setValue(`loads.${index}.PickupInstruction`, field?.pickupInstructions);
        setValue(`loads.${index}.DeliveryInstruction`, field?.deliveryInstructions);
        setValue(`loads.${index}.pickupLocation`, {
          source: field?.pickUpAddress,
          startLat: field?.pickUpLatitude,
          startLng: field?.pickUpLongitude
        });
        setPickupLocation((prev: any) => {
          let updatedLocation = [...prev];
          let pickupLocation = {
            formatted_address: field?.pickUpAddress,
            lat: field?.pickUpLatitude,
            lng: field?.pickUpLongitude
          };

          updatedLocation[index] = pickupLocation;
          return updatedLocation;
        });
        setValue(`loads.${index}.deliveryLocation`, {
          destination: field?.deliveryAddress,
          endLat: field?.deliveryLatitude,
          endLng: field?.deliveryLongitude
        });
        setDeliveryLocation((prev: any) => {
          let updatedLocation = [...prev];
          let deliveryLocation = {
            formatted_address: field?.deliveryAddress,
            lat: field?.pickUpLatitude,
            lng: field?.deliveryLongitude
          };
          updatedLocation[index] = deliveryLocation;
          return updatedLocation;
        });
        update(field, index);
      });
      setLoadData(
        filteredRow?.stackholder.map((field: any, index: number) => ({
          shipper: field?.shipperId,
          consignee: field?.consigneeId,
          pickupDate: field?.pickUpDate,
          deliveryDate: field?.deliveryDate,
          pickupLocation: {
            source: field?.pickUpAddress,
            startLat: field?.pickUpLatitude,
            startLng: field?.pickUpLongitude
          },
          deliveryLocation: {
            destination: field?.deliveryAddress,
            endLat: field?.deliveryLatitude,
            endLng: field?.deliveryLongitude
          },
          PickupInstruction: field?.pickupInstructions,
          DeliveryInstruction: field?.deliveryInstructions
        }))
      );
    }
  }, [filteredRow]);

  useEffect(() => {
    if (address) {
      setMapValue('address', {
        addressLocation: address?.formatted_address,
        addressLat: address?.lat,
        addressLng: address?.lng
      });
      dispatch(map([{ id: 1, lat: address?.lat, lng: address?.lng, name: 'location' }]));
      dispatch(
        updateCenter([{ id: 1, lat: address?.lat, lng: address?.lng, name: 'location' }])
      );
      dispatch(
        updateZoom([{ id: 1, lat: address?.lat, lng: address?.lng, name: 'location' }])
      );
    }
  }, [address]);

  useEffect(() => {
    return () => {
      handleClose();
    };
  }, []);

  return (
    <Box p={2}>
      <Dialog
        open={open}
        className='dialog animate__animated animate__zoomInRight'
        maxWidth={'md'}
        fullWidth
        slotProps={{
          backdrop: {
            invisible: true
          }
        }}
        sx={{ position: 'absolute', zIndex: 1 }}
      >
        <DialogContent sx={{ padding: ' 50px 50px' }}>
          {view ? (
            <>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <Typography sx={{ fontWeight: 700 }} className='add-load-title'>
                  {roleType}
                </Typography>
                <Box className='closeIcon icon-position d-flex' onClick={onClose}>
                  <CustomIconButton category='CloseValue' />
                </Box>
              </Box>
              <Box my={2} />
              <Grid
                container
                component={'form'}
                gap={2.8}
                spacing={1}
                onSubmit={handleSubmit(onSubmit)}
                className='load-containers animate__animated animate__zoomIn animate__slow'
              >
                <Grid item xs={12} sm={3.4} md={3.5} lg={disabled ? 5.8 : 3.8}>
                  <CustomSelect
                    control={control}
                    name='loadType'
                    placeholder='Load Type'
                    id='Load Type'
                    label='Load Type'
                    options={loadItems}
                    onChanges={(e: any, newValue: any) => {
                      setOptional(newValue?.id);
                      if (newValue?.id === 'Tanker' || newValue?.id === 'Refrigerator') {
                        setDisabled(true);
                        setValue('truckLoad', 'FTL');
                        clearErrors('truckLoad');
                      }
                      if (newValue?.id === 'General Cargo') {
                        setDisabled(false);
                      }
                      if (newValue === null) {
                        setValue('truckLoad', '');
                        setDisabled(false);
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={3.4} md={3.5} lg={disabled ? 5.8 : 3.8}>
                  <CustomSelect
                    control={control}
                    name='truckLoad'
                    placeholder='Truck Load'
                    id='truckLoad'
                    label='Truck Load'
                    options={truckLoadList}
                    isDisabled={disabled}
                  />
                </Grid>

                {!disabled && (
                  <Grid item xs={12} sm={3.4} md={3.5} lg={3.6}>
                    <CustomMultiSelect
                      options={freightName}
                      id='freight'
                      control={control}
                      name='freight'
                      label='Freight'
                      initialValue={filteredRow && filteredRow?.freightNumbers}
                      className={'freight-dropdown'}
                      placeholder='Freight'
                      setValue={setValue}
                      width={'170px'}
                      onChanges={(e: any, newValue: any) => {
                        setValue('freight', newValue);
                      }}
                    />
                  </Grid>
                )}

                <Grid item xs={12} sm={3.4} md={3.5} lg={3.8}>
                  <CustomSelect
                    control={control}
                    name='customer'
                    placeholder='Customer Name'
                    id='Customer'
                    label='Customer Name'
                    options={CustomerList}
                  />
                </Grid>

                <Grid item xs={12} sm={3.4} md={3.5} lg={3.7}>
                  <Box sx={{ position: 'relative' }}>
                    <Box sx={{ width: '100%', marginRight: '10px' }}>
                      <GoogleSearchBox
                        id='customer-address'
                        name='customeraddress'
                        control={control}
                        setValue={setValue}
                        label='Customer Address'
                        value={customerAddress && customerAddress?.formatted_address}
                        placeholder='Customer Address..'
                        onchange={(e: any) => {
                          if (!e.target.value) {
                            setValue('customeraddress', {});
                          }
                        }}
                        setAddress={(address: any) => {
                          handleCustomer(address);
                        }}
                      />
                    </Box>
                    <Icon
                      icon='fluent:location-ripple-12-filled'
                      width='20'
                      height='24'
                      style={{
                        color: '#ff0324',
                        position: 'absolute',
                        top: '30px',
                        right: '5px',
                        cursor: 'pointer'
                      }}
                      onClick={() => searchAddressDialog(index, 'customeraddress')}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={3.4} md={3.5} lg={3.7}>
                  <CustomTextField
                    control={control}
                    name='description'
                    placeholder='Reference'
                    id='reference'
                    label='Reference'
                  />
                </Grid>

                <Grid
                  container
                  sx={{ display: 'flex', justifyContent: 'flex-end' }}
                  className='set-loads'
                >
                  {fields?.map((field, index) => {
                    return (
                      <Grid
                        container
                        key={field.id}
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          alignItems: 'flex-end'
                        }}
                      >
                        {index > 0 && (
                          <Grid item xs={12}>
                            <Box my={2}>
                              <Divider sx={{ border: '1px dashed', color: '#B2BEB5' }} />
                            </Box>
                          </Grid>
                        )}

                        <Box my={2} />
                        <Grid container gap={2.5}>
                          <Grid item xs={12} sm={5.5} lg={5.8}>
                            <CustomSelect
                              control={control}
                              name={`loads.[${index}].shipper`}
                              placeholder='Shipper'
                              value={`loads.[${index}].shipper`}
                              id={`loads.[${index}]`}
                              label='Shipper'
                              selectedValue={ShipperList}
                              options={ShipperList}
                            />
                          </Grid>

                          <Grid item xs={12} sm={5.5} lg={5.8}>
                            <CustomSelect
                              control={control}
                              name={`loads.[${index}].consignee`}
                              placeholder='Consignee'
                              id={`loads.[${index}]`}
                              value={`loads.[${index}].consignee`}
                              label='Consignee'
                              options={ConsigneeList}
                            />
                          </Grid>

                          <Grid item xs={12} sm={5.5} lg={5.8} className='loads-date'>
                            <CustomDateTimeCalendar
                              id={`loads.[${index}]`}
                              label='Pickup Date'
                              name={`loads.${index}.pickupDate`}
                              control={control}
                              placeholder='Pickup Date'
                              disableFuture={false}
                              disablePast={true}
                              value={getValues(`loads.${index}.pickupDate`) || null}
                              format='DD/MM/YYYY hh:mm a'
                              onDateChange={(date: Date) => handleFromDate(index, date)}
                            />
                          </Grid>

                          <Grid item xs={12} sm={5.5} lg={5.8}>
                            <CustomDateTimeCalendar
                              id={`loads.[${index}]`}
                              label='Delivery Date'
                              name={`loads.${index}.deliveryDate`}
                              control={control}
                              placeholder='Delivery Date'
                              disableFuture={false}
                              disablePast={true}
                              value={getValues(`loads.${index}.deliveryDate`) || null}
                              format='DD/MM/YYYY hh:mm a'
                              onDateChange={(date: Date) => handleToDate(index, date)}
                              minDateTime={
                                pickupDate[index] !== null
                                  ? dayjs(pickupDate[index]?.getTime() + 3000 * 600)
                                  : null
                              }
                            />
                          </Grid>

                          <Grid item sm={5.5} xs={12} lg={5.8} className='loads-date'>
                            <Box sx={{ position: 'relative' }}>
                              <Box sx={{ width: '100%', marginRight: '10px' }}>
                                <GoogleSearchBox
                                  id={`loads.${index}.pickupLocation`}
                                  name={`loads.${index}.pickupLocation`}
                                  control={control}
                                  label='Pickup   Location'
                                  setValue={setValue}
                                  placeholder='Pickup Location..'
                                  value={
                                    pickupLocation &&
                                    pickupLocation[index]?.formatted_address
                                  }
                                  onchange={(e: any) => {
                                    if (!e.target.value) {
                                      setPickupLocation((prev: any) => {
                                        const updatedLocations = [...prev];
                                        updatedLocations[index] = {
                                          address: '',
                                          lat: null,
                                          lng: null
                                        };
                                        return updatedLocations;
                                      });
                                    }
                                  }}
                                  setAddress={(address: any) =>
                                    handlePickupLocationChange(index, address)
                                  }
                                />
                              </Box>
                              <Icon
                                icon='fluent:location-ripple-12-filled'
                                width='20'
                                height='24'
                                style={{
                                  color: '#ff0324',
                                  position: 'absolute',
                                  top: '30px',
                                  right: '5px',
                                  cursor: 'pointer'
                                }}
                                onClick={() =>
                                  searchAddressDialog(index, 'pickupLocation')
                                }
                              />
                            </Box>
                          </Grid>

                          <Grid item xs={12} lg={5.8} sm={5.5}>
                            <Box sx={{ position: 'relative' }}>
                              <Box sx={{ width: '100%', marginRight: '10px' }}>
                                <GoogleSearchBox
                                  id={`loads.${index}.deliveryLocation`}
                                  name={`loads.${index}.deliveryLocation`}
                                  control={control}
                                  label='Delivery Location'
                                  placeholder='Delivery Location..'
                                  value={
                                    deliveryLocation &&
                                    deliveryLocation[index]?.formatted_address
                                  }
                                  onchange={(e: any) => {
                                    if (!e.target.value) {
                                      setDeliveryLocation((prev: any) => {
                                        const updatedLocations = [...prev];
                                        updatedLocations[index] = {
                                          address: '',
                                          lat: null,
                                          lng: null
                                        };
                                        return updatedLocations;
                                      });
                                    }
                                  }}
                                  setAddress={(address: any) =>
                                    handleDeliveryLocationChange(index, address)
                                  }
                                />
                              </Box>
                              <Icon
                                icon='fluent:location-ripple-12-filled'
                                width='20'
                                height='24'
                                style={{
                                  color: '#ff0324',
                                  position: 'absolute',
                                  top: '30px',
                                  right: '5px',
                                  cursor: 'pointer'
                                }}
                                onClick={() =>
                                  searchAddressDialog(index, 'deliveryLocation')
                                }
                              />
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={5.5} lg={5.8}>
                            <CustomTextField
                              control={control}
                              name={`loads.${index}.PickupInstruction`}
                              value={`loads.${index}.PickupInstruction`}
                              placeholder='Pickup Instruction'
                              id={`loads.${index}.PickupInstruction`}
                              label='Pickup Instruction'
                              isOptional={true}
                            />
                          </Grid>

                          <Grid item xs={12} sm={5.5} lg={5.8}>
                            <CustomTextField
                              key={field.id}
                              control={control}
                              name={`loads.${index}.DeliveryInstruction`}
                              value={`loads.${index}.DeliveryInstruction`}
                              placeholder='Delivery Instruction'
                              id={`loads.${index}.DeliveryInstruction`}
                              label='Delivery Instruction'
                              isOptional={true}
                            />
                          </Grid>
                        </Grid>

                        {fields.length > 1 && index > 0 && (
                          <Grid
                            item
                            md={1}
                            pb={1}
                            sx={{ display: 'flex', justifyContent: 'flex-end' }}
                          >
                            <CustomIconButton
                              category='Delete'
                              onClick={() => {
                                remove(index);
                              }}
                            />
                          </Grid>
                        )}
                      </Grid>
                    );
                  })}
                  <Box my={2} />
                  <Box
                    sx={{
                      position: { xs: 'relative' },
                      right: { xs: '1%', lg: '1%', md: '2%' }
                    }}
                  >
                    <Grid item xs={2} lg={1}>
                      <CustomButton
                        className='custom-button-another'
                        category='Add'
                        size='small'
                        variant='outlined'
                        fullWidth
                        startIcon={<AddCircleOutline />}
                        onClick={handleFields}
                      />
                    </Grid>
                  </Box>
                </Grid>
                <Box>
                  <Typography>Load Dimensions</Typography>
                </Box>

                <Grid container spacing={2} className='dimension-fields'>
                  {dimensionFields?.map(item =>
                    item.id === '7' || item.id === '11' ? (
                      <Grid item xs={12} sm={3.8} lg={3.8}>
                        <CustomSelect
                          control={control}
                          name={item.field}
                          placeholder={item.placeholder}
                          id={item.id}
                          label={item.label}
                          options={item.options}
                        />
                      </Grid>
                    ) : (
                      <Grid item xs={12} lg={2.7} sm={3.8} key={item.id}>
                        <CustomTextField
                          control={control}
                          name={item.field}
                          placeholder={item.placeholder}
                          id={item.id}
                          isOptional={optional === 'Tanker' ? true : false}
                          label={item.label}
                          inputProps={item.inputProps}
                        />
                      </Grid>
                    )
                  )}
                </Grid>

                <Box my={2} />

                <Box
                  sx={{
                    marginTop: '5%',
                    display: 'flex',
                    gap: '15px',
                    position: { xs: 'relative', lg: 'relative' },
                    left: { lg: '74%', xs: '10%' }
                  }}
                >
                  <CustomButton
                    className='cancel'
                    category='Cancel'
                    onClick={() => {
                      handleClose();
                    }}
                  />
                  <CustomButton
                    className='saveChanges'
                    type='submit'
                    category={roleType}
                    loading={filteredRow ? updateLoading : addLoading}
                  />
                </Box>
              </Grid>
            </>
          ) : (
            <>
              <Box
                component={'form'}
                onSubmit={handleSubmit2(mapSubmit)}
                sx={{
                  display: 'flex',
                  width: '300px',
                  alignItems: 'center',
                  gap: '10px'
                }}
              >
                <Box className='address-box'>
                  <GoogleSearchBox
                    id='customer-address'
                    name='address'
                    control={mapControl}
                    label='Address'
                    placeholder='Search  Address..'
                    value={address?.formatted_address}
                    onchange={(e: any) => {
                      if (!e.target.value) {
                        setMapValue('address', {});
                        dispatch(map([]));
                      }
                    }}
                    setAddress={(address: any) => {
                      setAddress({
                        formatted_address: address?.formatted_address,
                        lat: address?.geometry?.location?.lat(),
                        lng: address?.geometry?.location?.lng()
                      });
                    }}
                  />
                </Box>
                <CustomButton
                  className='saveChanges'
                  type='submit'
                  category={'OK'}
                  sx={{
                    height: '35px',
                    marginLeft: '8px',
                    position: 'relative',
                    top: '10px'
                  }}
                />
              </Box>
              <Box
                className='closeIcon icon-position d-flex address-loads'
                onClick={onClose}
              >
                <CustomIconButton category='CloseValue' />
              </Box>
              <Box sx={{ width: '100%', height: '500px', marginTop: '20px' }}>
                <GoogleMap handleMapClick={handleMapClick}>
                  <GoogleMarkers />
                </GoogleMap>
              </Box>
            </>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default AddLoad;
